export default __webpack_public_path__ + "assets/images/050e2c193eb8101fbfb424771a2c0a72.svg";